import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n/config'
import { initDataCache } from './services/dataService'

// Disable service worker to prevent chrome-extension caching errors
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
    });
  });
}

// Pre-fetch candidates + elections from the live DB before first render.
// The app renders immediately with bundled JSON fallback; once the fetch
// resolves the cache is warm and all DataService.getCandidates() /
// getElections() calls return live data.
initDataCache().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
